{
  "comments": {
    "comment_form": {
      "placeholder": "Add a comment..."
    },
    "comment_thread_count": {
      "comments_count": "{{count}} comment in this thread",
      "comments_count_plural": "{{count}} comments in this thread"
    },
    "comment_thread": {
      "show_more": "Show more comments"
    },
    "comment_thread_slide": {
      "comments": "Comments"
    },
    "open_comment_thread_slide_button": {
      "open_comments": "view comments"
    }
  },
  "comment_actions": {
    "aria_label": "comment actions"
  },
  "comment_preview": {
    "edited": "Edited",
    "deleted_message": "This comment has been deleted."
  },
  "remove_comment": {
    "confirm_delete_title": "Are you sure you want to delete this comment?",
    "confirm_delete_content": "Click confirm to delete this comment"
  }
}
